import { UniconProduct } from '@types';
import { AgentLeadCard } from './lead.interface';

export interface Order {
  id: string;
  shipping: OrderShipping & {
    date?: string;
  };
  items: OrderItem[];
}

export interface ShippingPaginationResult {
  page: number;
  pageSize: number;
  lastPage: number;
  results: ShippingItemTime[];
}

export interface ShippingItemTime {
  time: string;
  availability: ShippingAvailability[];
}

export interface ShippingAvailability {
  startDateTime: string;
  endDateTime: string;
  isAvailable: boolean;
  isSelected?: boolean;
  dayName?: string;
}

export interface OrderShipping {
  department?: string;
  province?: string | null;
  district?: string;
  addressName?: string;
  latitude?: string;
  longitude?: string;
  locationStaticMapUrl?: string;
  freightZoneId?: number | null;
  unloadingMethodId?: number | null;
}

export interface OrderShippingQuoteLead {
  department?: string;
  province?: string | null;
  district?: string;
  addressName?: string;
  latitude?: string;
  longitude?: string;
  locationStaticMapUrl?: string;
  freightZoneId?: number;
  freightZoneName?: string;
  unloadingMethodId?: number;
  unloadingMethodName?: string;
  requiresFreightZone: boolean;
  requiresUnloadingMethod: boolean;
}

export interface OrderShippingQuote {
  startDateTime?: string;
  endDateTime?: string;
  department?: string;
  province?: string | null;
  district?: string;
  addressName?: string;
  latitude?: string;
  longitude?: string;
  locationStaticMapUrl?: string;
  contactName?: string;
  contactPhone?: string;
  email?: string;
  requiresFreightZone?: boolean;
  requiresUnloadingMethod?: boolean;
}

export interface OrderItem {
  id: string;
  businessLineId: number;
  businessLineName: UniconProduct;
  productId?: string;
  productVariantId?: string;
  productVariantName?: string;
  mixingCode?: string;
  measurementUnitName?: string;
  quantity: string;
  shippingStartDateTime?: string;
  shippingEndDateTime?: string;
}

export interface CreateOrUpdateOrderItem {
  businessLineId: number;
  productId: string;
  productVariantId: string;
  quantity: string;
  productVariantName?: string;
  mixingCode?: string;
}

export interface Quote {
  formattedAddress: string;
  startDateTime?: string;
  endDateTime?: string;
  items: QuoteItem[];
  subTotalAmount: number;
  netTotalAmount: number;
  taxAmount: number;
  totalAmount: number;
  orderId: string;
  quoteNumber: number;
  leadIdentificationDocumentNumber: string;
  leadIdentificationDocumentTypeId: number;
  leadIdentificationDocumentTypeName: string;
  leadAddress: LeadAddress;
  shipping: OrderShippingQuoteLead;
  leadNames: string;
  assignedAgent: AgentLeadCard;
  leadEmail: string;
  shippingContactInformation: ContactInformation;
  leadFirstSurname: string;
  leadSecondSurname: string;
}

export interface QuoteItem {
  productVariantName: string;
  quantity: string;
  measurementUnitName: string;
  unitPrice: number;
  finalPrice: number;
  id: string;
  businessLineId: number;
  businessLineName: string;
  shippingStartDateTime?: string;
  shippingEndDateTime?: string;
  freightUnitPrice: number;
  unloadingUnitPrice: number;
}
export interface Options {
  weekday: string;
}

export interface LeadsBySearch {
  leadCompleteName: string;
  orderStatusName: string;
  orderStatusId: number;
  orderId: string;
}

export enum ColumnTypes {
  ASSIGNED = 'Asignado',
  PROCESSING = 'En Atención',
  PAID = 'Pagado',
  QUOTED = 'Cotizado',
  SCHEDULED = 'En Programación',
  AFTERSALE = 'Post Venta',
}

export type ColumnNames = {
  [key in ColumnTypes]: string;
};

export interface NavListItemArchived {
  id: number;
  name: string;
  active: boolean;
  description: string;
}

export interface ItemArchived {
  orderId: string;
  leadCompleteName: string;
  orderAddress: string;
  businessLineItems: BusinessLineItemArchived[];
  disabledDate: string;
  disabledBy: string;
}

export interface BusinessLineItemArchived {
  businessLine: string;
  quantity: string;
  shippingDate?: string | null;
}

export interface ArchivedResult {
  page: number;
  lastPage: number;
  pageSize: number;
  totalRecords: number;
  results: ItemArchived[];
}

export enum ArchivedTypes {
  Provincia = 'Provincia',
  SinCobertura = 'Sin cobertura',
  Spam = 'Spam',
  LeadPerdido = 'Lead perdido',
  Inactividad = 'Inactividad',
  Otros = 'Otros',
}

export interface OrderPrice {
  unitPrice: number;
}

export interface OrderNote {
  notes: string;
}

export interface CommercialAgreement {
  leadEmail: string | null;
  leadDepartment: string | null;
  leadProvince: string | null;
  leadDistrict: string | null;
  leadStreetTypeId: number | null;
  leadAddressName: string | null;
  shippingContactName: string | null;
  shippingContactPhone: string | null;
}

export interface ContactInformation {
  completeName: string;
  phone: string;
}

export interface LeadAddress {
  addressName: string;
  department: string;
  district: string;
  province: string;
  streetTypeId: number;
}

export interface CommercialAgreementPreview {
  contactInformation: ContactInformation | null;
  id: string;
  items: OrderItem[];
  leadAddress: LeadAddress | null;
  leadEmail: string | null;
  leadId: string;
  leadFirstSurname: string | null;
  leadSecondSurname: string | null;
  leadIdentificationDocumentNumber?: string | null;
  leadIdentificationDocumentTypeId: number;
  leadIdentificationDocumentTypeName: 'DNI' | 'CE' | 'RUC';
  leadNames: string | null;
  orderShipping: OrderShipping;
  totalAmount?: number;
}

export interface FileType {
  id: string;
  name: string;
}

export interface ShippingDatesUpdate {
  businessLineId: number;
  shippingStartDateTime: string | null;
  shippingEndDateTime: string | null;
}

export interface FreightZone {
  id: number;
  name: string;
  description: string;
}

export interface UnloadingMethod {
  id: number;
  name: string;
  description: string;
}
